"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumnCount = void 0;
const react_1 = require("react");
const debounce_1 = __importDefault(require("debounce"));
const column_count_constants_1 = require("./column-count.constants");
const hooks_1 = require("../../../../../../hooks");
const useColumnCount = () => {
    const [columnCount, setColumnCount] = (0, react_1.useState)(column_count_constants_1.DEFAULT_COLUMN_COUNT);
    const onResize = (0, react_1.useCallback)((target) => {
        const containerWidth = target.clientWidth;
        const columnCount = Math.floor(containerWidth / (column_count_constants_1.ITEM_WIDTH + column_count_constants_1.ITEM_GAP));
        setColumnCount(Math.max(columnCount, column_count_constants_1.DEFAULT_COLUMN_COUNT));
    }, []);
    const handleResize = (0, react_1.useMemo)(() => (0, debounce_1.default)(onResize, 50), [onResize]);
    const ref = (0, hooks_1.useResizeObserver)(handleResize);
    return {
        ref,
        columnCount,
        itemWidth: column_count_constants_1.ITEM_WIDTH,
        itemMaxWidth: column_count_constants_1.ITEM_MAX_WIDTH,
    };
};
exports.useColumnCount = useColumnCount;
